export const priceValueParser = (product: any): number => {
    const normalPrice = product?.maximum_price
        ? product?.maximum_price?.regular_price?.value
        : product?.minimum_price?.regular_price?.value

    const discountPrice = product?.minimum_price?.final_price.value

    const hasDiscount = product?.minimum_price.discount?.amount_off >= 1

    return hasDiscount ? discountPrice : normalPrice
}
